import React, { useEffect, useState } from "react";

const DOCS = [
  {
    id: "d1",
    ic: "BO",
    col: "#12A4A0",
    t: "Bilan orthoptique",
    au: "Cabinet Orthoptie du Val",
    dt: "4 février",
    hit: true,
  },
  {
    id: "d2",
    ic: "OR",
    col: "#7C4DFF",
    t: "Ordonnance de lunettes",
    au: "Dr Hélène MARCHAND, ophtalmologiste",
    dt: "12 mars",
  },
  {
    id: "d3",
    ic: "CR",
    col: "#2F80ED",
    t: "Compte rendu de consultation",
    au: "Dr Hélène MARCHAND, ophtalmologiste",
    dt: "12 mars",
  },
];

const SECS = ["Comptes rendus", "Ordonnances", "Imagerie et examens"];

const STEPS = [
  {
    el: "dmp-pat",
    t: "1. Je retrouve mon patient",
    d: "Son nom, sa date de naissance. Le même patient que dans Osmose.",
  },
  {
    el: "dmp-acc",
    t: "2. Il donne son accord",
    d: "Le patient dit oui une fois, et son dossier médical partagé s'ouvre.",
  },
  {
    el: "dmp-find",
    t: "3. Je cherche, j'ouvre, je télécharge",
    d: "« bilan orthoptique » : le document est là. Un clic pour le lire ou le garder.",
  },
  {
    el: "dmp-dep",
    t: "4. J'y dépose mes documents",
    d: "Mon travail se range dans la bonne section, pour l'ophtalmo, l'orthoptiste et le patient.",
  },
];

export default function DmpFlow() {
  const [i, setI] = useState(0);

  useEffect(() => {
    const m = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)");
    if (m && m.matches) return undefined;
    const id = setInterval(() => setI((v) => (v + 1) % STEPS.length), 3400);
    return () => clearInterval(id);
  }, []);

  const spot = (name) => (STEPS[i].el === name ? " dmp-spot" : "");
  const open = i >= 1;
  const found = i >= 2;
  const sent = i >= 3;

  return (
    <div className="dmp">
      <style>{DCSS}</style>

      <div className="dmp-app">
        <aside className="dmp-rail">
          <div className={"dmp-pat" + spot("dmp-pat")}>
            <div className="dmp-lab">Mon patient</div>
            <div className="dmp-field">
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <circle cx="11" cy="11" r="7" fill="none" stroke="currentColor" strokeWidth="2" />
                <path d="m16.5 16.5 4 4" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
              </svg>
              Camille Rivière
            </div>
            <div className="dmp-card">
              <b>CR</b>
              <span>
                <span className="dmp-nm">Camille RIVIÈRE</span>
                <span className="dmp-sub">Née le 3 mars 1978</span>
              </span>
            </div>
          </div>

          <div className={"dmp-acc" + spot("dmp-acc")}>
            <div className="dmp-lab">Dossier médical partagé</div>
            <div className={"dmp-badge" + (open ? " dmp-badge-on" : "")}>
              <i />
              {open ? "Dossier ouvert" : "En attente de l'accord"}
            </div>
            <p className="dmp-auth">
              Le patient vous autorise à consulter son dossier. Il peut retirer son accord quand il
              veut.
            </p>
          </div>

          <div className="dmp-sec">
            <div className="dmp-lab">Où se rangent vos documents</div>
            {SECS.map((x) => (
              <div className={"dmp-srow" + (sent && x === SECS[0] ? " dmp-srow-on" : "")} key={x}>
                {x}
              </div>
            ))}
          </div>
        </aside>

        <div className="dmp-main">
          <div className="dmp-top">
            <h3>Dossier médical partagé de Camille RIVIÈRE</h3>
            <button type="button" className={"dmp-dep" + spot("dmp-dep")}>
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path
                  d="M12 16V4m0 0L7.5 8.5M12 4l4.5 4.5M4 17v2a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-2"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              Déposer un document
            </button>
          </div>

          <div className={"dmp-find" + spot("dmp-find")}>
            <div className="dmp-search">
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <circle cx="11" cy="11" r="7" fill="none" stroke="currentColor" strokeWidth="2" />
                <path d="m16.5 16.5 4 4" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
              </svg>
              {found ? "bilan orthoptique" : <em>Rechercher un document…</em>}
            </div>

            <div className="dmp-wrapl">
            <div className={"dmp-list" + (open ? "" : " dmp-blur")}>
              {DOCS.map((d) => {
                const on = found && d.hit;
                return (
                  <div className={"dmp-doc" + (on ? " dmp-sel" : "")} key={d.id}>
                    <span className="dmp-ic" style={{ background: d.col }}>
                      {d.ic}
                    </span>
                    <span className="dmp-bd">
                      <span className="dmp-ti">{d.t}</span>
                      <span className="dmp-au">{d.au}</span>
                    </span>
                    {on ? (
                      <span className="dmp-act">
                        <span className="dmp-b1">Ouvrir</span>
                        <span className="dmp-b2">Télécharger</span>
                      </span>
                    ) : (
                      <span className="dmp-dt">{d.dt}</span>
                    )}
                  </div>
                );
              })}

              {sent ? (
              <div className="dmp-doc dmp-new">
                <span className="dmp-ic" style={{ background: "#22A45D" }}>
                  AD
                </span>
                <span className="dmp-bd">
                  <span className="dmp-ti">
                    <span className="dmp-tag">Déposé par vous</span>
                    Adaptation de la prescription
                  </span>
                  <span className="dmp-au">Optique Rivage · section « Comptes rendus »</span>
                </span>
                <span className="dmp-dt">À l'instant</span>
              </div>
              ) : null}
            </div>
            {open ? null : (
              <div className="dmp-veil">
                <span>Le dossier s'ouvre avec l'accord du patient</span>
              </div>
            )}
            </div>
          </div>
        </div>
      </div>

      <div className="dmp-dots">
        {STEPS.map((s, n) => (
          <button
            key={s.t}
            type="button"
            aria-label={s.t}
            className={"dmp-dot" + (n === i ? " dmp-doton" : "")}
            onClick={() => setI(n)}
          />
        ))}
      </div>

      <ol className="dmp-caps">
        {STEPS.map((s, n) => (
          <li className={"dmp-cap" + (n === i ? " dmp-capon" : "")} key={s.t}>
            <b>{s.t}</b>
            <p>{s.d}</p>
          </li>
        ))}
      </ol>
    </div>
  );
}

const DCSS = `
.dmp{margin-top:30px}
.dmp *{box-sizing:border-box}
.dmp-app{background:#fff;border:1px solid #D8DCE2;border-radius:16px;overflow:hidden;
  box-shadow:0 26px 60px -34px rgba(15,23,42,.45);max-width:900px;margin:0 auto;display:flex}
.dmp-rail{width:280px;flex:0 0 280px;border-right:1px solid #E6E8EC;background:#FAFBFC;
  padding:16px 15px;display:flex;flex-direction:column;gap:14px}
.dmp-pat,.dmp-acc,.dmp-sec{border:1px solid #E6E8EC;border-radius:11px;background:#fff;padding:12px 13px;
  transition:box-shadow .2s,border-color .2s}
.dmp-lab{font-size:9.6px;font-weight:700;letter-spacing:.09em;text-transform:uppercase;color:#8A93A5}
.dmp-field{display:flex;align-items:center;gap:7px;margin-top:7px;font-size:12.4px;color:#0F172A;
  background:#F5F6F8;border:1px solid #E6E8EC;border-radius:9px;padding:7px 10px}
.dmp-field svg{width:14px;height:14px;flex:0 0 14px;color:#8A93A5}
.dmp-card{display:flex;align-items:center;gap:9px;margin-top:9px}
.dmp-card b{width:30px;height:30px;flex:0 0 30px;border-radius:999px;background:#0080FF;color:#fff;
  font-size:11px;font-weight:700;display:grid;place-items:center}
.dmp-nm{display:block;font-size:13px;font-weight:600;color:#0F172A;line-height:1.25}
.dmp-sub{display:block;font-size:10.8px;color:#8A93A5;margin-top:1px}

.dmp-badge{display:inline-flex;align-items:center;gap:7px;margin-top:7px;font-size:11.6px;
  font-weight:600;color:#8A93A5;background:#EFF1F5;border:1px solid #DDE1E8;border-radius:999px;
  padding:4px 11px;transition:background .25s,color .25s,border-color .25s}
.dmp-badge i{width:7px;height:7px;border-radius:999px;background:#B4BCC9;transition:background .25s}
.dmp-badge-on{background:#E8F7EE;border-color:#A8DCBE;color:#14532D}
.dmp-badge-on i{background:#00C950}
.dmp .dmp-auth{font-size:11.4px;line-height:1.5;color:#5A6478;margin:9px 0 0}

.dmp-srow{display:flex;align-items:center;gap:7px;font-size:11.8px;color:#5A6478;padding:6px 8px;
  border:1px solid transparent;border-radius:8px;margin-top:4px;transition:background .25s,color .25s,
  border-color .25s}
.dmp-srow:before{content:"";width:5px;height:5px;border-radius:999px;background:#CBD2DD;
  transition:background .25s}
.dmp-srow-on{background:#EAF4FF;border-color:#B9D9FB;color:#12406E;font-weight:600}
.dmp-srow-on:before{background:#0080FF}

.dmp-main{flex:1;min-width:0;display:flex;flex-direction:column}
.dmp-top{display:flex;align-items:center;gap:10px;padding:13px 16px 12px;border-bottom:1px solid #E6E8EC}
.dmp .dmp-top h3{font-size:14px;margin:0;color:#0F172A;font-weight:600;min-width:0}
.dmp-dep{margin-left:auto;display:inline-flex;align-items:center;gap:7px;font:inherit;font-size:11.8px;
  font-weight:600;color:#fff;background:#0080FF;border:1px solid #0080FF;border-radius:9px;
  padding:7px 12px;cursor:pointer;white-space:nowrap;transition:box-shadow .2s}
.dmp-dep svg{width:14px;height:14px;flex:0 0 14px}

.dmp-find{margin:10px;padding:6px;border:1px solid transparent;border-radius:12px;
  transition:box-shadow .2s,border-color .2s}
.dmp-search{display:flex;align-items:center;gap:8px;font-size:12.6px;color:#0F172A;background:#F5F6F8;
  border:1px solid #E6E8EC;border-radius:9px;padding:8px 11px}
.dmp-search svg{width:15px;height:15px;flex:0 0 15px;color:#8A93A5}
.dmp-search em{font-style:normal;color:#A2AAB8}
.dmp-wrapl{position:relative}
.dmp-list{display:grid;gap:5px;margin-top:8px;transition:filter .4s,opacity .4s}
.dmp-blur{filter:blur(4px);opacity:.4;user-select:none}
.dmp-veil{position:absolute;inset:0;display:grid;place-items:center}
.dmp-veil span{font-size:12px;font-weight:600;color:#5A6478;background:#fff;border:1px solid #E6E8EC;
  border-radius:999px;padding:7px 14px;box-shadow:0 8px 22px -16px rgba(15,23,42,.6)}
.dmp-doc{display:grid;grid-template-columns:34px 1fr auto;gap:10px;align-items:center;
  padding:9px 10px;border:1px solid transparent;border-radius:10px;
  transition:background .2s,border-color .2s,box-shadow .2s}
.dmp-ic{width:34px;height:34px;border-radius:9px;display:grid;place-items:center;font-size:11px;
  font-weight:700;color:#fff}
.dmp-bd{min-width:0}
.dmp-ti{display:block;font-size:12.8px;font-weight:600;color:#0F172A;line-height:1.35}
.dmp-au{display:block;font-size:10.8px;color:#8A93A5;margin-top:2px}
.dmp-dt{font-size:11px;color:#8A93A5;white-space:nowrap}
.dmp-sel{background:#EAF4FF;border-color:#B9D9FB}
.dmp-act{display:flex;gap:6px}
.dmp-b1,.dmp-b2{font-size:11px;font-weight:600;border-radius:8px;padding:5px 10px;white-space:nowrap}
.dmp-b1{background:#0080FF;color:#fff;border:1px solid #0080FF}
.dmp-b2{background:#fff;color:#12406E;border:1px solid #B9D9FB}
.dmp-new{background:#F7FAFF;animation:dmp-in .38s ease both}
@keyframes dmp-in{from{opacity:0;transform:translateY(-6px)}to{opacity:1;transform:none}}
.dmp-tag{display:inline-block;font-size:9.4px;font-weight:700;letter-spacing:.04em;
  text-transform:uppercase;background:#E3F0FF;color:#12406E;border:1px solid #B9D9FB;
  border-radius:999px;padding:2px 7px;margin-right:6px;vertical-align:1px}

.dmp-spot{border-color:#0080FF!important;box-shadow:0 0 0 4px rgba(0,128,255,.15)}
.dmp-dep.dmp-spot{box-shadow:0 0 0 4px rgba(0,128,255,.22)}

.dmp-dots{display:flex;gap:7px;justify-content:center;margin-top:18px}
.dmp-dot{width:8px;height:8px;padding:0;border:0;border-radius:999px;background:#CBD2DD;
  cursor:pointer;transition:background .2s,width .2s}
.dmp-doton{width:22px;background:#0080FF}

.dmp-caps{list-style:none;margin:26px 0 0;padding:0;display:grid;
  grid-template-columns:repeat(4,1fr);gap:12px}
.dmp-cap{border:1px solid transparent;border-radius:12px;padding:14px 16px;
  transition:background .18s,border-color .18s}
.dmp-cap b{display:block;font-size:14.2px;color:#8A93A5;transition:color .18s}
.dmp .dmp-cap p{font-size:13px;line-height:1.55;color:#98A1B2;margin:5px 0 0;transition:color .18s}
.dmp-capon{background:#fff;border-color:#E6E8EC;box-shadow:0 10px 26px -22px rgba(15,23,42,.5)}
.dmp-capon b{color:#0F172A}
.dmp .dmp-capon p{color:#5A6478}

@media (max-width:980px){
  .dmp-app{flex-direction:column}
  .dmp-rail{width:auto;flex:none;border-right:0;border-bottom:1px solid #E6E8EC;flex-direction:row}
  .dmp-rail>*{flex:1}
  .dmp-caps{grid-template-columns:repeat(2,1fr)}
}
@media (max-width:640px){
  .dmp-rail{flex-direction:column}
  .dmp-top{flex-wrap:wrap}
  .dmp-dep{margin-left:0}
  .dmp-act{flex-direction:column}
  .dmp-caps{grid-template-columns:1fr}
}
`;
